<template>
  <el-submenu :index="menu.path">
    <template slot="title">
      <i :class="`fa fa-${menu.icon || 'folder-o'}`"></i>
      <span>{{ menu.title || '未命名菜单' }}</span>
    </template>
    <template v-for="item of menu.children">
      <side-submenu-tree :key="item.path" v-if="item.children && item.children.length > 0" :menu="item" />
      <side-submenu-item :key="item.path" v-else :menu="item" />
    </template>
  </el-submenu>
</template>

<script>
import SideSubmenuItem from './SideSubmenuItem'

export default {
  name: 'SideSubmenuTree',
  components: { SideSubmenuItem },
  props: {
    menu: {
      type: Object,
      required: true
    }
  }
}
</script>
